export enum ModalSize {
  NORMAL = "normal",
  EXTENDED = "extended",
  RESIZABLE = "resizable",
}

export interface ModalComponent {
  type: string;
  draggable?: boolean;
  resizable?: boolean;
  size?: ModalSize;
  props: any;
}

export enum OverlaySize {
  NORMAL = "normal",
  EXTENDED = "extended",
  REDUCED = "reduced",
  EXTRA_REDUCED = "extra_reduced",
  // 923-core-context context/engineering/spark-rewards/phase-54-give-recognition-drawer.md: a right-hand drawer, not a width variant of the centred modal
  // every other OverlaySize member is -- OverlayWrapper/index.scss's own `.overlay-wrapper_size-drawer`
  // rule overrides position/height/radius/shadow for this value ONLY, leaving every other size's centred
  // layout untouched.
  DRAWER = "drawer",
}

export interface OverlayComponent {
  type: string;
  size?: OverlaySize;
  closeOnOverlayClick: boolean;
  leaveConfirm?: boolean;
  props: any;
  class?: string;
}
